export default __webpack_public_path__ + "static/media/(19).e611035f.jpg";